/** True when the browser sends the Global Privacy Control opt-out signal. */
export const globalPrivacyControl = (): boolean =>
  typeof navigator !== 'undefined' &&
  (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true;
